"use strict";
exports.__esModule = true;
exports.BRANDING_TYPE_OPTIONS = void 0;
exports.BRANDING_TYPE_OPTIONS = ['COMPANY', 'PROPERTY'];
//# sourceMappingURL=branding-type-options.js.map